import React from 'react';
import Layout from '../Layout';
import Main from 'gatsby-theme-carbon/src/components/Main';
import { useMetadata } from 'gatsby-theme-carbon/src/util/hooks';
import { Helmet } from 'react-helmet';


const Homepage = ({
  children,
  Banner,
  FirstCallout,
  SecondCallout,
  location,
  pageContext,
}) => {
  const { frontmatter = {}, titleType } = pageContext;
  const { title, description, keywords } = frontmatter;
  const { homepageTheme } = useMetadata();

  return (
    <Layout
      pageTitle={title}
      pageDescription={description}
      pageKeywords={keywords}
      titleType={titleType}
      homepage
      theme={homepageTheme}>
      {Banner}
      {FirstCallout}
      <Main>{children}</Main>
      {SecondCallout}
      {/* <NextPrevious isHomepage location={location} pageContext={pageContext} /> */}
      {typeof window !== "undefined" && !window.location.href.includes("localhost")  && <Helmet>
                <script type = "text/javascript">{`
                    window.digitalData = {
                        page: {
                            category: {
                                primaryCategory: 'NO_CATEGORY_ASSIGNED',
                            },
                            pageInfo: {
                                ibm: {
                                    siteID: 'IBM_ACCESSIBILITY',
                                }
                            },
                        }
                    };`}
                </script>
                <script src="//1.www.s81c.com/common/stats/ibm-common.js" type="text/javascript" async="async"></script>
            </Helmet>}
    </Layout>
  );
};

export default Homepage;
